module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plTableBox",
    class: {
      fix: _vm.fixCol
    },
    style: ([_vm.plTableHeight])
  }, [_c('el-table', {
    ref: "singleTable",
    staticClass: "singleTable",
    attrs: {
      "data": _vm.isArrayFn(_vm.data) ? _vm.data : [],
      "max-height": _vm.newMaxHeight,
      "height": _vm.newHeight,
      "select-tr-class": _vm.selectTrClass,
      "use-virtual": _vm.height && parseInt(_vm.height) > 0 || _vm.maxHeight && parseInt(_vm.maxHeight) > 0 ? _vm.useVirtual : false,
      "excess-rows": _vm.excessRows,
      "border": _vm.border,
      "data-changes-scroll-top": _vm.dataChangesScrollTop,
      "stripe": _vm.stripe,
      "row-key": _vm.rowKey,
      "fixed-columns-roll": _vm.fixedColumnsRoll,
      "fit": _vm.fit,
      "show-header": _vm.showHeader,
      "row-class-name": _vm.rowClassName,
      "cell-class-name": _vm.cellClassName,
      "header-row-class-name": _vm.headerRowClassName,
      "header-row-style": _vm.headerRowStyle,
      "header-cell-class-name": _vm.headerCellClassName,
      "header-cell-style": _vm.headerCellStyle,
      "row-style": _vm.rowStyle,
      "cell-style": _vm.cellStyle,
      "big-data-checkbox": _vm.bigDataCheckbox,
      "thtd-beyond-hiding": _vm.thtdBeyondHiding,
      "size": _vm.size,
      "default-sort": _vm.defaultSort,
      "default-expand-all": _vm.defaultExpandAll,
      "expand-row-keys": _vm.expandRowKeys,
      "tree-props": _vm.treeProps,
      "tree-config": _vm.treeConfig,
      "select-on-indeterminate": _vm.selectOnIndeterminate,
      "span-method": _vm.arraySpanMethod,
      "rowHeight": _vm.rowHeight,
      "tooltipEffect": _vm.tooltipEffect,
      "current-row-key": _vm.currentRowKey,
      "tooltipPlacement": _vm.tooltipPlacement,
      "header-drag-style": _vm.headerDragStyle,
      "highlight-current-row": _vm.highlightCurrentRow,
      "show-summary": _vm.showSummary,
      "summary-method": _vm.getSummaries
    },
    on: {
      "row-click": _vm.rowClick,
      "row-dblclick": _vm.rowDblclick,
      "expand-change": _vm.expChang,
      "tableBodyScroll": _vm.tableBodyScroll,
      "header-dragend": _vm.headerDragend,
      "cell-mouse-enter": _vm.cellMouseEnter,
      "cell-mouse-leave": _vm.cellMouseLeave,
      "cell-click": _vm.cellClick,
      "cell-dblclick": _vm.cellDblclick,
      "row-contextmenu": _vm.rowContextmenu,
      "header-contextmenu": _vm.headerContextmenu,
      "header-click": _vm.headerClick,
      "select": _vm.plSelect,
      "select-all": _vm.selectAll,
      "selection-change": _vm.handleSelectionChange,
      "filter-change": _vm.filterChange,
      "current-change": _vm.currentChange,
      "sort-change": _vm.sortChange
    }
  }, [_c('template', {
    slot: "empty"
  }, [_vm._t("empty", [_vm._v(_vm._s(_vm.emptyText))])], 2), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.paginationShow) ? _c('div', {
    ref: "myPagination",
    staticClass: "myPagination"
  }, [_c('el-pagination', {
    style: (_vm.paginationStyle),
    attrs: {
      "current-page": _vm.newcurrentPage,
      "pager-count": _vm.pagerCount,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.newPageSize,
      "layout": _vm.layout,
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "plDialog",
    staticClass: "plDialog"
  }, [(_vm.plDialogFals) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "table-cus-header"
  }, [_vm._v(_vm._s(_vm.fieldTitle))]), _vm._v(" "), _c('div', {
    staticClass: "checkListBox"
  }, [_c('draggable', {
    attrs: {
      "tag": "ul",
      "options": {
        disabled: !_vm.fieldSort
      }
    },
    model: {
      value: (_vm.newDialogData),
      callback: function($$v) {
        _vm.newDialogData = $$v
      },
      expression: "newDialogData"
    }
  }, _vm._l((_vm.newDialogData), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('el-checkbox', {
      attrs: {
        "disabled": item.disabled
      },
      model: {
        value: (item.state),
        callback: function($$v) {
          _vm.$set(item, "state", $$v)
        },
        expression: "item.state"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.showAmend) ? _c('i', {
      staticClass: "iconfont",
      class: [_vm.amendBtnIcon || 'el-icon-edit'],
      on: {
        "click": function($event) {
          return _vm.amendField(item, index)
        }
      }
    }) : _vm._e()], 1)
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-cus-footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmField
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-47044984","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ni-ui/table/table.vue
// module id = 8Hb/
// module chunks = 81